import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// pages
// 登录
import login from "@/pages/login/login";
// 首页
import index from "@/pages/index/index";

// view 内容
// index首页
import indexHome from "@/view/index/index";
import homeData from "@/view/home/data";

import errorPage from "@/view/errorPage/index"; //403页面

import user from "./view/user"; // user 用户管理

import device from "./view/device"; //设备管理
import common from "./view/common"; //常见问题
import collect from "./view/collect"; //采集显示管理
import fault from "./view/fault"; //故障录波
import electric from "./view/electric"; //电能质量
import message from "./view/message"; //消息提醒
import upgrade from "./view/upgrade"; //升级固件

import examine from "./view/examine"; //审核管理
import service from "./view/service"; //增值服务
import feedback from "./view/feedback"; //用户反馈

import system from "./view/system"; //系统管理
import waveform from "./view/waveform"; //波形库管理
import banner from "./view/banner"; //banner管理
import operate from "./view/operate"; //操作日记

import dictionary from './view/dictionary'
import protocolFrom from './view/protocolFrom'
// import systemMenu from '@/view/system/menu/list';

export default new Router({
  // mode: 'history',//去掉#号、
  mode: "hash", //保留#号、
  routes: [
    {
      path: "/loginMode",
      name: "loginMode",
      component: login,
    },
    // {
    // 	path: '/',
    // 	redirect: '/home/data' // 添加重定向规则
    //   },
    {
      path: "/",
      component: index,
      children: [
        {
          path: "/",
          name: "homeData",
          component: homeData,
        },
        {
					path: '/password',
					name: 'password',
					component: () => import('@/pages/password/index')
				},
        {
					path: '/info',
					name: 'info',
					component: () => import('@/pages/info/index')
				},
        {
          path: "/home/data",
          name: "homeData",
          component: homeData,
        },
        {
          path: "/errorPage",
          name: "errorPage",
          component: errorPage,
        },
        ...user,
        ...device,
        ...common,
        ...collect,
        ...fault,
        ...electric,
      
        ...operate,
        ...message,
        ...upgrade,
        ...examine,
        ...service,
        ...feedback,
        ...system,
        ...waveform,
        ...banner,
        ...dictionary,
        ...protocolFrom,
  
        // {
        // 	path: '/system/menu',
        // 	name: 'systemMenu',
        // 	component: systemMenu
        // }
      ],
    },
  ],
});
